@file:OptIn(kotlin.time.ExperimentalTime::class)

package or.garden.manager.util

import kotlinx.datetime.LocalDateTime
import kotlinx.datetime.TimeZone
import kotlinx.datetime.format
import kotlinx.datetime.format.char
import kotlinx.datetime.toLocalDateTime
import kotlin.time.Instant

fun formatTimestampToHuman(tsString: String): String {
    val instant = Instant.parse(tsString)
        .toLocalDateTime(TimeZone.currentSystemDefault())

    val dateFormat = LocalDateTime.Format {
        day()
        char('.')
        monthNumber()
        char('.')
        year()
        char('.')
        char(' ')
        hour()
        char(':')
        minute()
    }

    return instant.format(dateFormat)
}
